<div class="case-overview-content" boiStickyRightPanel>
    <div class="case-left-side" [ngClass]="{'width-100': !hasRightSidePanel}">
        <ng-content select="[mainContent]"></ng-content>
    </div>
    <div *ngIf="hasRightSidePanel" class="case-right-side fixed-wrapper">
        <div class="fixable-right-content">
            <ng-content select="[rightHandPanel]"></ng-content>
        </div>
    </div>
</div>